import '@rdfjs/data-model';
import '../../rdf.internal.mjs';
import 'http-link-header';
import 'n3';
import '../../rdfjs.mjs';
import { getThing, createThing } from '../../thing/thing.mjs';
import { getIriAll } from '../../thing/get.mjs';
import 'cross-fetch';
import { buildThing } from '../../thing/build.mjs';
import { internal_getAcr } from '../control.internal.mjs';
import { ACP } from '../constants.mjs';
import { setModes } from './setModes.mjs';
import { setAccessControlResourceThing } from './setAccessControlResourceThing.mjs';
import 'uuid';
import { getDefaultAgentMatcherPolicyUrl } from './getDefaultAgentMatcherPolicyUrl.mjs';
import { setDefaultAgentMatcherPolicyThingIfNotExist } from './setDefaultAgentMatcherPolicyThingIfNotExist.mjs';
import { getDefaultAgentMatcherPolicyMatcherUrl } from './getDefaultAgentMatcherPolicyMatcherUrl.mjs';

//
/** @hidden */
const DEFAULT_POLICY_MATCHER_PREDICATE = ACP.anyOf;
/**
 * This functions scaffolds the default elements required for giving access to
 * an agent:
 * 1. If the Access Control Resource is empty, create the AccessControlResource
 *    element;
 * 2. If the current default Access Control doesn't exist (the one applying to
 *    one of: the Resource, the ACR, the Member Resources or the ACR of members)
 *    create it;
 * 3. If the default Policy for allowing the Access Modes for the current
 *    default Access Control doesn't exist, create it;
 * 4. If the default "anyOf" Agent Matcher for the current Policy creates it;
 * 5. Returns an ACR with a Matcher ready to add to.
 * @hidden
 * */
function setDefaultAgentMatcherPolicyMatcherThingIfNotExist(resource, name, mode) {
    const policyUrl = getDefaultAgentMatcherPolicyUrl(resource, name, mode);
    const matcherUrl = getDefaultAgentMatcherPolicyMatcherUrl(resource, name, mode);
    let defaultAgentMatcherPolicyThing = getThing(internal_getAcr(resource), policyUrl);
    if (!defaultAgentMatcherPolicyThing) {
        resource = setDefaultAgentMatcherPolicyThingIfNotExist(resource, name, mode);
        defaultAgentMatcherPolicyThing = createThing({ url: policyUrl });
        defaultAgentMatcherPolicyThing = setModes(defaultAgentMatcherPolicyThing, { [mode]: true }, ACP.allow);
    }
    // Get the Default Access Control Agent Matcher Policy Matcher Thing or create it and return
    const agentMatcherPolicyUrlAll = getIriAll(defaultAgentMatcherPolicyThing, DEFAULT_POLICY_MATCHER_PREDICATE);
    if (!agentMatcherPolicyUrlAll.includes(matcherUrl)) {
        defaultAgentMatcherPolicyThing = buildThing(defaultAgentMatcherPolicyThing)
            .addUrl(DEFAULT_POLICY_MATCHER_PREDICATE, matcherUrl)
            .build();
        return setAccessControlResourceThing(resource, defaultAgentMatcherPolicyThing);
    }
    return resource;
}

export { DEFAULT_POLICY_MATCHER_PREDICATE, setDefaultAgentMatcherPolicyMatcherThingIfNotExist };
